import { Button } from "@shopify/polaris";
import { trackEvent } from "../lib/mixpanel";
import { ToggleOnIcon } from "@shopify/polaris-icons";
import { ChatIcon } from "@shopify/polaris-icons";
import { isDesktop } from "../lib/isDesktop";
import { useGetStore } from "../api/useGetStore";

export function AppEnableDisableButton() {
  const { data, isLoading, isError } = useGetStore();
  const shopName = data ? data.data.shopName : "";
  const qs = new URLSearchParams();
  qs.append("template", "index");
  qs.append(
    "addAppBlockId",
    process.env.REACT_APP_SHOPIFY_API_KEY + "/age-verification-44"
  );
  qs.append("target", "mainSection");
  const automaticAttachLink = `https://${shopName}/admin/themes/current/editor?${qs.toString()}`;

  function onContactSupport() {
    trackEvent("Contact Support Clicked");
  }

  let message = encodeURIComponent(
    `Hi, I am facing issues in adding the widget on my store. Can you help me out?`
  );
  const link = `https://wa.me/+918076623211?text=${message}`;

  return (
    <>
      <div style={{ display: "flex", gap: 10 }}>
        <Button
          onClick={onContactSupport}
          url={link}
          external={true}
          icon={ChatIcon}
        >
          {isDesktop ? "Customer Support" : ""}
        </Button>
        <Button
          icon={ToggleOnIcon}
          disabled={isLoading}
          onClick={async () => {
            if (!data || isError) {
              trackEvent("Add Widget to Storefront Error");
              return;
            }

            window.open(automaticAttachLink, "_top");
            trackEvent("Add Widget to Storefront Clicked");
          }}
        >
          {isDesktop ? "Add Widget to Store" : "Add Widget"}
        </Button>
      </div>
    </>
  );
}
